import { createSelector } from 'reselect';
import {
    DesignFileAnalysis,
    ImportedTemplate,
    ImportTargetDpi,
    ImportTemplateState,
    ImportType,
    MultiDesignMode,
} from './types';
import { UploadType } from 'packages/store/uploads/types';

const getImportTemplate = (state: any): ImportTemplateState => state.importTemplate;

export const getImportedTemplate = (state: any): ImportedTemplate => state.importTemplate.template;
export const isImportTemplateLoading = (state: any): boolean => state.importTemplate.loading;
export const getImportTemplateErrors = (state: any): any => state.importTemplate.errors;
export const getImportTemplateValidationErrors = (state: any): any[] => state.importTemplate.validationErrors;
export const getImportTemplateType = (state: any): ImportType => state.importTemplate.type;
export const getImportTemplateAnalysis = (state: any): DesignFileAnalysis => state.importTemplate.designFileAnalysis;
export const getImportTemplateMultiDesignMode = (state: any): MultiDesignMode['multiDesignMode'] =>
    state.importTemplate.multiDesignMode;
export const getImportTemplateTargetDpi = (state: any): ImportTargetDpi => state.importTemplate.targetDpi;
export const getImportTemplateProgress = (state: any): number => state.importTemplate.progress;
export const getImportActionProgress = createSelector(
    getImportTemplate,
    (importTemplate): { addingInProgress: ImportTemplateState['addingInProgress'] } => ({
        addingInProgress: importTemplate.addingInProgress,
    }),
);
export const getPendingUploadForImport = (state: any): UploadType | undefined =>
    state.importTemplate.pendingUploadForImport;
